import { render, staticRenderFns } from "./WorkOrderTagsSelect.vue?vue&type=template&id=cada7400&"
import script from "./WorkOrderTagsSelect.vue?vue&type=script&lang=js&"
export * from "./WorkOrderTagsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports